import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDrawer2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDrawer2"><Path d="M3.5 3.5H20.5V18.5H3.5V3.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M12 11L3.5 11" stroke="currentColor" strokeLinecap="square"/><Path d="M12 3.5V18.5" stroke="currentColor" strokeLinecap="square"/><Path d="M6.5 18.5V21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M17.5 18.5V21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M14.5 9.5V12.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconDrawer2;
